import { PathFunction, compile, ParamData } from 'path-to-regexp';
import queryString from 'query-string';
import { RouteQueryResult } from 'shared/models/RouteQueryResult';

export type CompilePathParams = {
  [key: string]: string | number | string[] | number[];
};

type CompilePathCache = {
  [key: string]: PathFunction<ParamData>;
};

const compilePathCache: CompilePathCache = {};

export function compilePath(
  pattern: string,
  params?: CompilePathParams,
  query?: RouteQueryResult
): string {
  if (!compilePathCache[pattern]) {
    compilePathCache[pattern] = compile(pattern);
  }

  // Convert params to match ParamData type (string | string[] only)
  const convertedParams: ParamData = {};
  if (params) {
    for (const [key, value] of Object.entries(params)) {
      if (Array.isArray(value)) {
        convertedParams[key] = value.map((v) => String(v));
      } else {
        convertedParams[key] = String(value);
      }
    }
  }

  const compiledPath = compilePathCache[pattern](convertedParams);
  const stringifiedQuery = queryString.stringify(query);

  return stringifiedQuery ? `${compiledPath}?${stringifiedQuery}` : compiledPath;
}
